import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";
// import {GameCenterHeaderModulePlaceholder} from "./placeholders/game-center-header-module.placeholder";

const GameCenterHeaderModuleAsyncComponent = AsyncComponent(async () => import('./game-center-header-module' /* webpackChunkName: "game-center-header-module" */ ));

export const GameCenterHeaderModuleAsync = (props) => {
  return <GameCenterHeaderModuleAsyncComponent {...props}/>
};
